import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SpinAndHold2 } from "../SpinAndHold/SpinAndHold2";
import { SpinAndHold2Params } from "../SpinAndHold/SpinAndHold2Params";
import { SpinAndHoldSession } from "../SpinAndHold/SpinAndHoldSession";

export class ExtendedSpinAndHold2 extends SpinAndHold2 {
	protected override BonusName(): string {
		return "ExtendedSpinAndHold";
	}

	//protected remainingSpinsCanvas: MyCanvas = null;
	//protected ctxWremainingSpinsCanvas: MyCanvasContext = null;

	public constructor(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration) {
		super(gameResid, params, config);
	}

	protected override StickySpinTitle(resourceManager: ResourceManager) {
		// this.StickyBonusSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("StickyBonus").Add("StickyTitle")).sprite, canvasSize: new Size(Scale.W(1000), Scale.H(350)}));
		// this.StickyBonusSprite.View().style.position = "absolute";
		// this.StickyBonusSprite.View().style.top = Scale.Ypx(-100);
		// this.StickyBonusSprite.View().style.display = "none";
		// this.StickyBonusSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));
		// this.StickyBonus.style.zIndex = ZIndex.HoldAndStopTitle.toString();
		// this.StickyBonus.appendChild(this.StickyBonusSprite.View());
	}

	protected override RemainigContainer(resourceManager) {
		// super.RemainigContainer(resourceManager)
		// this.freegameStats.style.bottom = Scale.Ypx(800);
		// this.freegameStats.style.right = Scale.Xpx(-500);
	}

	public override StickyBonusLoaded(resourceManager: IReadOnlyResourceManager) {
		//super.StickyBonusLoaded(resourceManager);
		// this.winStats.style.left= Scale.Xpx(-500);
		// this.winStats.style.position = "absolute";
		// this.winStats.style.top = Scale.Xpx(-200);
	}

	protected override BigCountAnimation(resourceManager: ResourceManager) {

	}

	public override Update(): void {
		// //this.transition.Update();

		// this.WinValueSprite.Update();
		// this.ContainerSprite.Update();
		// this.SFXBackground.Update();
		// this.StickyBonusSprite.Update();
		// this.FrameSprite.Update();
		// this.BonusWinSprite.Update();
	}

	protected override ResetShowWin() {
		// //this.FrameSprite.View().style.display="none";
		// this.winContainer.style.display="none";
		// //this.WinValueSprite.View().style.display="block";
		// this.ContainerSprite.View().style.display="block";
		// this.SFXBackground.View().style.display="block";
		// this.winCountcanvas.View().style.display="block";
		// //this.totalwin.style.display="block";
		// this.left.style.display="block";
		// //this.win.style.display="block";
		// if(this.bigWinCountAnimation!=null){
		// 	this.bigWinCountAnimation.View().style.visibility = "visible";
		// 	this.bigWinCountAnimation.View().style.display="block";
		// }
		// this.remainingSpinsCanvas.View().style.display="none";
		// //Create twwin anim for hide 
		// this.StickyBonusSprite.Show();
		// //this.BonusWinSprite.Hide();
		//this.remainingSpinsCanvas.View().style.display = "block";
	}

	protected override OnPlus(session: SpinAndHoldSession): void {

		// if (session == null) {
		// 	throw new Error("Session must not be null");

		// }

		// if (session.RunsRemaining > this.session.RunsRemaining) {
		// 	//this.SFXBackground.Start(false);
		// 	//this.StickyBonusSprite.Start(false);
		// 	//this.WinValueSprite.Start(false);


		// }

		// this.session.Update(session);
		// setTimeout(() => this.ApplySession(), 300);
	}

	protected override StartShowWin() {
		// TweenMax.fromTo(this.winContainer, 2.5, {
		// 	x: this.viewSize.width,
		// }, {
		// 	x: Scale.X(110), ease: Elastic.easeOut.config(0.50, 0.4)
		// });

		// this.tl.repeat(0);
		// this.tl.play();

		// //this.FrameSprite.View().style.display="block";
		// this.WinValueSprite.View().style.display = "none";
		// this.ContainerSprite.View().style.display = "none";
		// this.SFXBackground.View().style.display = "none";
		// this.winCountcanvas.View().style.display = "none";
		// this.totalwin.style.display = "none";
		// this.left.style.display = "none";
		// if (this.bigWinCountAnimation != null) {
		// 	this.bigWinCountAnimation.View().style.visibility = "hidden";
		// }
		// this.win.style.display = "none";
		// this.WinCanvasShow.View().style.display = "block";
		// this.winContainer.style.display = "flex";
		// this.StickyBonusSprite.Hide();
		// this.BonusWinSprite.Show();
		//this.SetTextCanvas(this.translator.t.goodluck, this.ctxWremainingSpinsCanvas, this.remainingSpinsCanvas)
	}

	protected override CreateShowAnim() {
	}

	protected override CanvaswinCount(resourceManager: ResourceManager) {
		// this.fontHeight = Scale.fh(100);
		// this.remainingSpinsCanvas = new MyCanvas(new Size(Scale.W(this.viewSize.width), Scale.H(200)), {
		// 	style: {
		// 		top: Scale.Ypx(-44),
		// 		//left: Scale.Xpx(114),
		// 		position: "absolute",
		// 		alignItems: "center",
		// 		justifyContent: "center",
		// 		zIndex: "" + ZIndex.BonusWin,
		// 		display: "none",
		// 	}
		// });

		// //add gradient
		// this.ctxWremainingSpinsCanvas = this.remainingSpinsCanvas.context;

		// //this.ctx.font = "120px Verdana" /*+ this.font*/;
		// this.ctxWremainingSpinsCanvas.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount");

		// let color: string = "white";
		// let color2: string = "white";

		// let gradient = this.ctxWremainingSpinsCanvas.createLinearGradient(
		// 	this.remainingSpinsCanvas.size.width / 2,
		// 	this.remainingSpinsCanvas.size.height / 2 - this.fontHeight / 2,
		// 	this.remainingSpinsCanvas.size.width / 2,
		// 	this.remainingSpinsCanvas.size.height / 2 + this.fontHeight / 2
		// );


		// gradient.addColorStop(0, color);

		// gradient.addColorStop(0.70, color2);


		// gradient.addColorStop(1, color);


		// this.ctxWremainingSpinsCanvas.fillStyle = gradient;

		// this.ctxWremainingSpinsCanvas.textBaseline = "top";
		// this.ctxWremainingSpinsCanvas.textAlign = "center";




		// this.view.appendChild(this.remainingSpinsCanvas.view);
		// this.SetTextCanvas(this.translator.t.spin, this.ctxWremainingSpinsCanvas, this.remainingSpinsCanvas);
		// this.translator.SetOnLanguageChangedCallback(() => {
		// 	if (this.session.RunsRemaining > 0) {
		// 		this.SetTextCanvas(this.translator.t.extendendDiamondSpinRemaining(this.session.RunsRemaining), this.ctxWremainingSpinsCanvas, this.remainingSpinsCanvas)
		// 	}
		// 	else {
		// 		this.SetTextCanvas(this.translator.t.extendendLasSpinMessage, this.ctxWremainingSpinsCanvas, this.remainingSpinsCanvas);
		// 	}
		// });
	}

	// public override SetTextCanvas(text: string, ctx: MyCanvasContext, winCountcanvas: MyCanvas) {
	// 	// ctx.clearRect(0, 0, winCountcanvas.size.width, winCountcanvas.size.height);
	// 	// ctx.strokeStyle = "black";
	// 	// ctx.lineWidth = Scale.fh(10);
	// 	// ctx.strokeText(text, (winCountcanvas.size.width / 2), (winCountcanvas.size.height / 4));

	// 	// //ctx.strokeStyle = "white";
	// 	// //ctx.lineWidth =Scale.fh(10)/2;
	// 	// //ctx.strokeText(text,(winCountcanvas.size.width/2),(winCountcanvas.size.height/4));

	// 	// ctx.fillText(text, (winCountcanvas.size.width / 2), (winCountcanvas.size.height / 4));
	// }

	protected override CanvaswinCountShow(resourceManager: ResourceManager) {
	}

	protected override ApplySession() {
		// if (this.session.RunsRemaining > 0) {
		// 	this.SetTextCanvas(this.translator.t.diamondSpinRemaining(this.session.RunsRemaining), this.ctxWremainingSpinsCanvas, this.remainingSpinsCanvas)
		// }
		// else {
		// 	this.SetTextCanvas(this.translator.t.extendendLasSpinMessage, this.ctxWremainingSpinsCanvas, this.remainingSpinsCanvas)
		// }
	}


	protected override UpdateWinValue(Win: number) {


	}

	protected override OnFinalMessageBegin() {


	}

	protected override OnFinalMessageEnd() {

	}

	public override Stop() {

	}

	public override Start(): void {
		// if (this.session == null) {
		// 	throw new Error("Session must not be null");

		// }

		// this.session.Reset();
		// this.ResetShowWin();

	}

	protected override SpriteWinFramePrepare(resourceManager: IWriteOnlyResourceManager) {
	}

	protected override SpriteWinFrameLoaded(resourceManager: IReadOnlyResourceManager) {
	}

	protected override BonusWinLoaded(resourceManager: IReadOnlyResourceManager) {
	}

	public override TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
	}
}